import {IVStoreState} from '../useIVStore';

export const getDocumentNationality = (state: IVStoreState) =>
  state.setupData.nationality;
